import i18n from 'helpers/i18n';
import messages from './messages';
import pdf from 'images/reliabilityTest/pdf-blue.svg';
import { getChartData } from 'components/ReliabilityTest/utils';
import PassMessage from 'components/ReliabilityTest/PassMessage';
import { THRESHOLD } from 'components/ReliabilityTest/constants';
import NotPassMessage from 'components/ReliabilityTest/NotPassMessage';
import Chart from 'components/ReliabilityTest/DoughnutChartPanel/Chart';
import { Score, ChartContainer } from 'components/ReliabilityTest/Styled';

export interface CalibrationResultSectionProps {
  title: string;
  testScore: number;
  expertCodes: string;
}

function CalibrationResultSection(props: CalibrationResultSectionProps) {
  var { title, testScore, expertCodes } = props;
  const chartData = getChartData(testScore);

  function renderChart() {
    return (
      <div className=" flex flex-col items-center justify-center h-full w-full rounded-2xl bg-[#E0EAD5] p-6 min-h-[300px]">
        <ChartContainer aria-labelledby="test-score">
          <div aria-hidden="true">
            <Chart data={chartData} />
          </div>
          <Score aria-hidden="true">{testScore}%</Score>
          <span className="sr-only" id="test-score">
            {`${i18n.ft(messages.score)} ${testScore}%`}
          </span>
        </ChartContainer>
        <div className="mt-6 text-center">
          {testScore >= THRESHOLD ? (
            <div className="font-bold text-lg mb-2">
              {i18n.ft(messages.scoreAbove)}
              <span className="font-bold mr-4">{` ${THRESHOLD}%!`}</span>
            </div>
          ) : (
            <div className="font-bold text-lg mb-2">
              {i18n.ft(messages.scoreBelow)}
              <span className="font-bold mr-4">{` ${THRESHOLD}%`}</span>
            </div>
          )}
          <div className="text-base font-normal">
            {i18n.ft(messages.videoCriteria)}
          </div>
        </div>
      </div>
    );
  }

  function renderExpertCodes() {
    const isDisabled = !expertCodes;

    return (
      <div className=" flex flex-col items-center justify-center h-full w-full rounded-2xl bg-[#D1DAE5] p-6 min-h-[300px]">
        <div className="flex justify-center mb-4">
          <img src={pdf} alt={i18n.ft(messages.pdf)} className="" />
        </div>
        <div className="mb-4 text-center text-base font-normal">
          {i18n.ft(messages.ExpertCodes)}
        </div>
        <a
          href={expertCodes ? expertCodes : undefined}
          target={expertCodes ? '_blank' : undefined}
          rel="noopener noreferrer"
          className={`block sm:w-[165px] md:w-[265px] h-[45px] mx-auto mt-2 text-xl rounded-lg bg-[#385E8E] text-white font-bold text-center leading-[45px] transition-opacity duration-200 ${isDisabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'hover:bg-[#27466b]'}`}
          tabIndex={isDisabled ? -1 : 0}
          aria-disabled={isDisabled}
        >
          {i18n.ft(messages.button)}
        </a>
      </div>
    );
  }

  return (
    <div className="PrintBackgroundColor PrintPaddingBottom bg-[#F9F9F9] mb-0 p-1 sm:px-8 sm:py-3 lg:px-20 lg:py-3 lg:mx-12">
      {/* Header Section */}
      <div className="grid justify-center mx-auto font-bold text-2xl leading-[29px] mb-2">
        {testScore >= THRESHOLD ? (
          <PassMessage title={title} testType="preparation" />
        ) : (
          <NotPassMessage title={title} />
        )}
      </div>
      {/* Main Content Grid */}
      <div className="grid gap-6 auto-rows-[1fr] items-stretch justify-center grid-cols-2 sm:py-3">
        {renderChart()}
        {renderExpertCodes()}
      </div>
    </div>
  );
}

export default CalibrationResultSection;
